/* eslint-disable max-len */
import { axiosWCApiInstance } from '../Configurations/AxiosConfiguration';
import { ExpenseStatusEnum } from '../Components/Expense/ExpenseStatus.enum';
import { ExpenseBillTypeEnum } from '../Components/Expense/BillType.enum';
import { ExpenseSourceEnum } from '../Components/Expense/ExpenseSource.enum';
import { PreCodedStatusEnum } from '../Components/Expense/PreCodedStatus.enum';
import { checkFeatureFlag } from '../../components/GlobalComponents/FeatureFlagComponent/FeatureFlag';

export const getClinicianAssignments = async (bookingId) => {
    try {
        const url = `assignments/${bookingId}`;
        const response = await axiosWCApiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getClinician = async (clinicianId) => {
    try {
        const url = `clinicians/${clinicianId}`;
        const response = await axiosWCApiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createExpense = async (expense) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses', expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateExpense = async (key, expense) => {
    try {
        const response = await axiosWCApiInstance.put(`/expenses/${key}`, expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseImageById = async (expenseId, imageId, isPrecoded) => {
    try {
        const response = await axiosWCApiInstance.get(
            `/expenses/${expenseId}/images/${imageId}?isPrecoded=${isPrecoded}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteExpenseImageById = async (expenseId, imageId, isPrecoded) => {
    try {
        const response = await axiosWCApiInstance.delete(
            `/expenses/${expenseId}/images/${imageId}?isPrecoded=${isPrecoded}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseById = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.get(`/expenses/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getVaultExpensesById = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.get(`/expenses/vault/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const regenerateVaultPdf = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.post(`/vault/regenerate-pdf/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenses = async () => {
    try {
        const response = await axiosWCApiInstance.get('/administration/expenses');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getPendingCCExpenseById = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.get(`/expenses/precoded/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createPendingCCExpense = async (expense) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses/precoded', expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updatePendingCCExpense = async (key, expense) => {
    try {
        const response = await axiosWCApiInstance.put(`/expenses/precoded/${key}`, expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createExpenseImage = async (imgData) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses/images', imgData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const postImageForOCR = async (img, documentType) => {
    try {
        const form = new FormData();
        form.append('documentData', img);

        const response = await axiosWCApiInstance.post(`/ocr?documentType=${documentType}`, form, {
            timeout: 20000,
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const uploadExpensesFile = async (formData) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses/upload', formData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getAllCreditCards = async () => {
    try {
        const response = await axiosWCApiInstance.get('/administration/CreditCards');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getStatusesAllowed = async (expClass) => {
    try {
        const response = await axiosWCApiInstance.get(`/expenses/statuses?expClass=${expClass}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getNeedsReviewReasons = async () => {
    try {
        const response = await axiosWCApiInstance.get('/expenses/errorCodes');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseCategories = async (expenseTypeSelection) => {
    try {
        let aExpenseTypeSelection = expenseTypeSelection;
        if (!aExpenseTypeSelection) {
            aExpenseTypeSelection = 'All';
        }
        const response = await axiosWCApiInstance.get(
            `expenseTypes?expenseTypeSelection=${aExpenseTypeSelection}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const searchVendors = async (searchString) => {
    try {
        const url = `vendors/search/${searchString}`;
        const response = await axiosWCApiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const refreshVendors = async () => {
    try {
        const url = `refresh-vendors`;
        const response = await axiosWCApiInstance.get(url);

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

const getKeyFromValueStatus = (value) => {
    for (const index in ExpenseStatusEnum) {
        const statusEnum = ExpenseStatusEnum[index].UI;
        if (statusEnum === value) {
            return ExpenseStatusEnum[index].value;
        }
    }
    // If nothing is found in ExpenseStatusEnum, check PreCodedStatusEnum
    for (const index in PreCodedStatusEnum) {
        const statusEnum = PreCodedStatusEnum[index].UI;
        if (statusEnum === value) {
            return PreCodedStatusEnum[index].value;
        }
    }
};

const getKeyFromValue = (value, type) => {
    // const noSpace = value.replace(' ', '');
    for (const index in type) {
        const statusEnum = type[index];
        if (statusEnum === value) {
            return index;
        }
    }
};

const getUrlParams = async ({
    offset,
    sortBy,
    sortDirection,
    limit,
    statuses,
    divisions,
    transactionStartDate,
    transactionEndDate,
    expenseTypes,
    sources,
    needsReviewReasons,
    hasReceipt,
    billTypes,
    startStartDate,
    startEndDate,
    endStartDate,
    endEndDate,
    postStartDate,
    postEndDate,
    periodEndStart,
    periodEndEnd,
    payDateStart,
    payDateEnd,
    submittedStartDate,
    submittedEndDate,
    merchantStates,
    importedStart,
    importedEnd,
    search,
    searchKey,
    expenseClass,
    creditCardList,
}) => {
    const offsetParam = `Offset=${offset}`;
    const expenseClassParam = expenseClass ? `&ExpenseClass=${expenseClass}` : '';
    const pageSizeParam = `&PageSize=${limit}`;
    const statusParams = statuses
        ?.map((status) => `&Statuses=${getKeyFromValueStatus(status)}`)
        .join('');
    const divisionParams = divisions?.map((division) => `&Divisions=${division}`).join('');
    const expenseTypeParams = expenseTypes
        ?.map((expenseType) => `&ExpenseType=${expenseType}`)
        .join('');

    let sourcesToMap = sources;
    const isNCREFFEnabled = await checkFeatureFlag(
        'NonClinicianReimbursementExpenseFeatures',
        false
    );

    if (!isNCREFFEnabled && sourcesToMap.length === 0) {
        sourcesToMap = ['Reimbursement (Associate)', 'Reimbursement (Clinician)'];
    }

    const sourceParams = sourcesToMap
        ?.map((source) => `&Source=${getKeyFromValue(source, ExpenseSourceEnum)}`)
        .join('');
    const needsReviewParams = needsReviewReasons
        ?.map((reason) => `&NeedsReviewReason=${reason.toUpperCase().replace(/ /g, '_')}`)
        .join('');

    const hasReceiptValue =
        hasReceipt?.includes('Yes') && !hasReceipt.includes('No')
            ? '1'
            : hasReceipt?.includes('No') && !hasReceipt.includes('Yes')
            ? '0'
            : null;
    const hasReceiptParam = hasReceiptValue ? `&HasReceipt=${hasReceiptValue}` : '';

    const billTypeParams = billTypes
        ?.map((billType) => `&BillType=${getKeyFromValue(billType, ExpenseBillTypeEnum)}`)
        .join('');
    const merchantStateParams = merchantStates
        ?.map((merchantState) => `&MerchantState=${merchantState}`)
        .join('');
    const sortParams = sortBy ? `&OrderBy=${sortBy}&Dir=${sortDirection}` : '';
    const transactionDateStartParam = transactionStartDate
        ? `&TransactionDateStart=${transactionStartDate}`
        : '';
    const transactionDateEndParam = transactionEndDate
        ? `&TransactionDateEnd=${transactionEndDate}`
        : '';
    const startDateStartParam = startStartDate ? `&StartDateStart=${startStartDate}` : '';
    const startDateEndParam = startEndDate ? `&StartDateEnd=${startEndDate}` : '';
    const endDateStartParam = endStartDate ? `&EndDateStart=${endStartDate}` : '';
    const endDateEndParam = endEndDate ? `&EndDateEnd=${endEndDate}` : '';
    const postDateStartParam = postStartDate ? `&PostDateStart=${postStartDate}` : '';
    const postDateEndParam = postEndDate ? `&PostDateEnd=${postEndDate}` : '';
    const payDateStartParam = payDateStart ? `&PayDateStart=${payDateStart}` : '';
    const payDateEndParam = payDateEnd ? `&PayDateEnd=${payDateEnd}` : '';
    const periodEndDateStartParam = periodEndStart ? `&PeriodEndDateStart=${periodEndStart}` : '';
    const periodEndDateEndParam = periodEndEnd ? `&PeriodEndDateEnd=${periodEndEnd}` : '';
    const importedStartParam = importedStart ? `&ImportedDateStart=${importedStart}` : '';
    const importedEndParam = importedEnd ? `&ImportedDateEnd=${importedEnd}` : '';
    const submittedDateStartParam = submittedStartDate
        ? `&SubmittedDateStart=${submittedStartDate}`
        : '';
    const submittedDateEndParam = submittedEndDate ? `&SubmittedDateEnd=${submittedEndDate}` : '';
    let searchColumns;
    const hasSearch = !!searchKey;
    if (hasSearch) {
        const isSearchKeyArray = Array.isArray(searchKey.value);
        searchColumns = isSearchKeyArray
            ? searchKey.value.map((key) => `&SearchColumns=${key}`).join('')
            : `&SearchColumns=${searchKey.value}`;
    }
    const searchParams = search ? `&SearchWord=${search}${searchColumns}` : '';
    const creditCardParams = creditCardList
        ?.map((creditCardId) => `&CreditCardIdList=${creditCardId}`)
        .join('');

    return {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        hasReceiptParam,
        billTypeParams,
        merchantStateParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        importedStartParam,
        importedEndParam,
        searchParams,
        expenseClassParam,
        creditCardParams,
    };
};

export const getExpensesCSVWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        billTypeParams,
        merchantStateParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
    } = await getUrlParams(request);

    const url = `administration/expenses/csv?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        expenseTypeParams ? `${expenseTypeParams}` : ''
    }${sourceParams ? `${sourceParams}` : ''}${needsReviewParams ? `${needsReviewParams}` : ''}${
        billTypeParams ? `${billTypeParams}` : ''
    }${merchantStateParams ? `${merchantStateParams}` : ''}${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${
        postDateStartParam ? `${postDateStartParam}` : ''
    }${postDateEndParam ? `${postDateEndParam}` : ''}${
        periodEndDateStartParam ? `${periodEndDateStartParam}` : ''
    }${payDateStartParam ? `${payDateStartParam}` : ''}${
        payDateEndParam ? `${payDateEndParam}` : ''
    }${periodEndDateEndParam ? `${periodEndDateEndParam}` : ''}${
        submittedDateStartParam ? `${submittedDateStartParam}` : ''
    }${submittedDateEndParam ? `${submittedDateEndParam}` : ''}${
        searchParams ? `${searchParams}` : ''
    }${expenseClassParam ? `${expenseClassParam}` : ''}`;

    const response = await axiosWCApiInstance
        .get(url.endsWith('&') ? url.slice(0, -1) : url, {
            responseType: 'blob', // Important: Ensures the response is a Blob
        })
        .catch(async (error) => {
            if (error instanceof Blob && error.type) {
                const text = await error.text();
                const json = JSON.parse(text);
                if (json === 'No expense data found.') {
                    const errorResponse = {
                        status: 404,
                        message: json,
                        data: null,
                    };
                    return errorResponse;
                }
            }
            throw error;
        });
    return response;
};

export const getVaultExpensesCSVWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        hasReceiptParam,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
        importedStartParam,
        importedEndParam,
    } = await getUrlParams(request);

    const url = `administration/expenses/vault/csv?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        expenseTypeParams ? `${expenseTypeParams}` : ''
    }${sourceParams ? `${sourceParams}` : ''}${needsReviewParams ? `${needsReviewParams}` : ''}${
        hasReceiptParam ? `${hasReceiptParam}` : ''
    }${billTypeParams ? `${billTypeParams}` : ''}${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${
        postDateStartParam ? `${postDateStartParam}` : ''
    }${postDateEndParam ? `${postDateEndParam}` : ''}${
        periodEndDateStartParam ? `${periodEndDateStartParam}` : ''
    }${payDateStartParam ? `${payDateStartParam}` : ''}${
        payDateEndParam ? `${payDateEndParam}` : ''
    }${periodEndDateEndParam ? `${periodEndDateEndParam}` : ''}${
        submittedDateStartParam ? `${submittedDateStartParam}` : ''
    }${importedStartParam ? `${importedStartParam}` : ''}${
        importedEndParam ? `${importedEndParam}` : ''
    }${submittedDateEndParam ? `${submittedDateEndParam}` : ''}${
        searchParams ? `${searchParams}` : ''
    }${expenseClassParam ? `${expenseClassParam}` : ''}`;

    const response = await axiosWCApiInstance
        .get(url.endsWith('&') ? url.slice(0, -1) : url, {
            responseType: 'blob',
        })
        .catch(async (error) => {
            if (error instanceof Blob && error.type) {
                const text = await error.text();
                const normalizedMessage = text.replace(/^"|"$/g, '');

                if (
                    normalizedMessage === 'No vault expenses found matching the specified criteria.'
                ) {
                    return {
                        status: 404,
                        message: normalizedMessage,
                        data: null,
                    };
                }

                try {
                    const json = JSON.parse(text);
                    throw {
                        status: json.status ?? 500,
                        message: json.message,
                        error: json.error,
                        innerError: json.innerError,
                        stackTrace: json.stackTrace,
                        timestamp: json.timestamp,
                        requestId: json.requestId,
                    };
                } catch {
                    throw new Error(normalizedMessage || 'Failed to download Vault CSV.');
                }
            }
            throw error;
        });

    return response;
};

export const getExpensesWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        billTypeParams,
        merchantStateParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        importedStartParam,
        importedEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
    } = await getUrlParams(request);

    const url = `administration/expenses?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        expenseTypeParams ? `${expenseTypeParams}` : ''
    }${sourceParams ? `${sourceParams}` : ''}${needsReviewParams ? `${needsReviewParams}` : ''}${
        billTypeParams ? `${billTypeParams}` : ''
    }${merchantStateParams ? `${merchantStateParams}` : ''}${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${
        postDateStartParam ? `${postDateStartParam}` : ''
    }${postDateEndParam ? `${postDateEndParam}` : ''}${
        periodEndDateStartParam ? `${periodEndDateStartParam}` : ''
    }${payDateStartParam ? `${payDateStartParam}` : ''}${
        payDateEndParam ? `${payDateEndParam}` : ''
    }${periodEndDateEndParam ? `${periodEndDateEndParam}` : ''}${
        submittedDateStartParam ? `${submittedDateStartParam}` : ''
    }${importedStartParam ? `${importedStartParam}` : ''}${
        importedEndParam ? `${importedEndParam}` : ''
    }${submittedDateEndParam ? `${submittedDateEndParam}` : ''}${
        searchParams ? `${searchParams}` : ''
    }${expenseClassParam ? `${expenseClassParam}` : ''}`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const getVaultChargesWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        hasReceiptParam,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
        importedStartParam,
        importedEndParam,
    } = await getUrlParams(request);

    const url = `administration/expenses/vault?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        expenseTypeParams ? `${expenseTypeParams}` : ''
    }${sourceParams ? `${sourceParams}` : ''}${needsReviewParams ? `${needsReviewParams}` : ''}${
        hasReceiptParam ? `${hasReceiptParam}` : ''
    }${billTypeParams ? `${billTypeParams}` : ''}${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${
        postDateStartParam ? `${postDateStartParam}` : ''
    }${postDateEndParam ? `${postDateEndParam}` : ''}${
        periodEndDateStartParam ? `${periodEndDateStartParam}` : ''
    }${payDateStartParam ? `${payDateStartParam}` : ''}${
        payDateEndParam ? `${payDateEndParam}` : ''
    }${periodEndDateEndParam ? `${periodEndDateEndParam}` : ''}${
        submittedDateStartParam ? `${submittedDateStartParam}` : ''
    }${importedStartParam ? `${importedStartParam}` : ''}${
        importedEndParam ? `${importedEndParam}` : ''
    }${submittedDateEndParam ? `${submittedDateEndParam}` : ''}${
        searchParams ? `${searchParams}` : ''
    }${expenseClassParam ? `${expenseClassParam}` : ''}`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const getPreCodedWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        expenseTypeParams,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
    } = await getUrlParams(request);

    const url = `administration/precoded?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        expenseTypeParams ? `${expenseTypeParams}` : ''
    }${billTypeParams ? `${billTypeParams}` : ''}${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const getCreditCardWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        expenseTypeParams,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        searchParams,
        expenseClassParam,
        creditCardParams,
    } = await getUrlParams(request);

    const url = `administration/expenses/creditcard?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        expenseTypeParams ? `${expenseTypeParams}` : ''
    }${billTypeParams ? `${billTypeParams}` : ''}${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${searchParams ? `${searchParams}` : ''}${
        expenseClassParam ? `${expenseClassParam}` : ''
    }${creditCardParams ? `${creditCardParams}` : ''}`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const updateHighPriority = async (key, highPriority) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const response = await axiosWCApiInstance.put(
            `/expenses/${key}/HighPriority`,
            highPriority,
            config
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseHistory = async (expenseId, isPrecoded) => {
    try {
        const response = await axiosWCApiInstance.get(
            `/expenses/${expenseId}/history?isPrecoded=${isPrecoded}`
        );
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return [];
        }
        console.error(error);
        throw error;
    }
};
